import React from 'react';
import ReactDOM from 'react-dom';
import { CourseWizard } from './components/index.js'

const elements = [...document.querySelectorAll('.wp-block-salsa-blocks-course-wizard')]
elements.forEach(element => {
    if (element) {
        // console.log(element)
        // const {
        //     query,
        //     filterMenuEnabled,
        //     searchEnabled,
        //     selectedTaxonomies,
        //     columns = 3,
        //     rows = 3,
        //     sortByEnabled,
        //     sortByDefault,
        //     sortDirectionDefault,
        //     selectedSortOptions,
        //     loadMoreEnabled
        // } = JSON.parse(element.dataset.blockAttributes)
        ReactDOM.render(
            <React.StrictMode>
                <CourseWizard />
            </React.StrictMode>,
            element
        );
    }
})
